import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  ChangeDetectorRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { ApiRequestService } from "@common/services";

@Component({
  selector: "metering-farm-single-select",
  templateUrl: "./metering-farm-single-select.component.html",
  styleUrls: ["./metering-farm-single-select.component.scss"],
})
export class MeteringFarmSingleSelectComponent implements OnInit {
  farms: any[] = [];
  farmControl = new FormControl(null);

  @Output() farmSelected = new EventEmitter<any>();
  meteringFarms: any = [];

  perPageMF: any = 10;
  pageNumberMF: any = 1;
  meteringFarmSearchTerm: any = "";
  hasMoreFarms: boolean = true;
  mfLoading: boolean = false;

  constructor(
    private http: HttpClient,
    private changeDetectorRef: ChangeDetectorRef,
    private apiRequest: ApiRequestService
  ) {}

  ngOnInit(): void {
      this.fetchFarms(true);
  }


  onSelect(farm: any) {
    this.farmSelected.emit(farm);
  }

  onClear() {
    this.farmSelected.emit(null);
  }

  onMFValueChange(event: any) {
    if (!event) {
      console.log("Selection cleared/backspaced");
      this.onClearMF();
    } else {
      this.farmSelected.emit(event.meteringFarmID);
      console.log("Selected ID:", event.meteringFarmID);
      console.log("Selected Name:", event.meteringFarmName);
    }
  }

  onFilterMF(event: any) {
    this.pageNumberMF = 1;
    this.meteringFarmSearchTerm = event.term?.trim() || "";
    this.hasMoreFarms = true;
    this.fetchFarms(true);
  }

  onClearMF() {
    this.farmSelected.emit(true);
    this.pageNumberMF = 1;
    this.meteringFarmSearchTerm = "";
    this.hasMoreFarms = true;

    // this.pageNumber = 1;
    // this.meteringSections = [];
    // this.meteringSectionSearchTerm = ''
    // this.hasMore = true;

    // this.pageNumberMP = 1;
    // this.meteringPoints = [];
    // this.meteringPointSearchTerm = ''
    // this.hasMoreMP = true;

    // this.meteringForm.patchValue({
    //   meteringSectionID: null,
    //   meteringPointID: null
    // });

    this.fetchFarms(true);
  }

  fetchFarms(reset: boolean) {
    console.log(this.hasMoreFarms , 'hasMoreFarm')
    if (!this.hasMoreFarms) {
      return;
    }

    this.changeDetectorRef.detectChanges();

    this.mfLoading = true;

    const body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
        searchTerm: this.meteringFarmSearchTerm,
        perPage: this.perPageMF,
        page: this.pageNumberMF,
      },
    };

    this.apiRequest
      .apiRequest(
        "metering/metering_farms_list_paginated/",
        "metering_farms_list_paginated.json",
        body
      )
      .subscribe({
        next: (res: any) => {
          if (res.success && res.data) {
            const newData = res.data.meteringFarms || [];

            // ✅ reset if new search
            if (reset) {
              this.meteringFarms = newData;
            } else {
              this.meteringFarms = [...this.meteringFarms, ...newData];
            }

            // ✅ stop pagination if no more data
            if (newData.length == 0) {
              this.hasMoreFarms = false;
            }
          } else {
            if (reset) {
              this.meteringFarms = [];
              this.hasMoreFarms = false;
            }
          }
          this.mfLoading = false;
          this.changeDetectorRef.detectChanges();
        },
        error: () => {
          this.mfLoading = false;
          if (reset) {
            this.meteringFarms = [];
            this.hasMoreFarms = false;
          }

          this.changeDetectorRef.detectChanges();
        },
      });
  }

  loadMoreFarms() {
    this.pageNumberMF++;
    this.fetchFarms(false);
  }
}
